module.exports = __webpack_public_path__ + "static/media/CassieBoyd-resume.1f32a385.pdf";